import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { GroupLayer } from '@/model/document2/page/surface/design/layer/groupLayer';
import { Design } from '@/model/document2/page/surface/design/design';
import { NumberLayer } from '@/model/document2/page/surface/design/layer/numberLayer';

// レイヤーの削除コマンド
export class DeleteLayerCommand implements ICommandBase
{
    private deleteLayer! : Layer;
    private parent! : GroupLayer;
    private design! : Design;
    private doneCallback! : () => void;

    private currentLayer : Layer | null;
    private deleteIndex : number = 0;

    constructor(deleteLayer : Layer, parent : GroupLayer, design : Design, doneCallback : () => void)
    {
        this.deleteLayer = deleteLayer;
        this.parent = parent;
        this.design = design;
        this.doneCallback = doneCallback;
        // カレントレイヤー保持
        this.currentLayer = design.currentLayer;
        // アンドゥのときにインデックスが必要になる
        this.deleteIndex = parent.getLayerIndex(deleteLayer);
    }

    public do() : void
    {
        if(this.currentLayer == this.deleteLayer)
        {
            // 消去対象がカレントレイヤーの場合はカレントを外す
            this.design.currentLayer = null;
        }

        // 消去対象が選択レイヤーにあった場合は選択を外す
        var isSelected = false;
        for(var layer of this.design.selectLayers)
        {
            if(layer == this.deleteLayer)
            {
                isSelected = true;
                break;
            }
        }
        if(isSelected)
        {
            this.design.removeSelectLayer(this.deleteLayer);
        }

        // レイヤーの削除
        this.parent.removeLayer(this.deleteLayer);

        // 連番文字対応
        if(this.deleteLayer instanceof NumberLayer) { this.deleteLayer.updateDocument(false); }

        this.doneCallback();
    }

    public undo() : void
    {
        // レイヤーの追加
        this.parent.insertLayer(this.deleteIndex, this.deleteLayer);

        if(this.currentLayer == this.deleteLayer)
        {
            // 消去レイヤーがカレントレイヤーだった場合はカレントを戻す
            this.design.currentLayer = this.currentLayer;
        }

        // 連番文字対応
        if(this.deleteLayer instanceof NumberLayer) { this.deleteLayer.updateDocument(true); }

        this.doneCallback();
    }

    public redo() : void
    {
        if(this.currentLayer == this.deleteLayer)
        {
            // 消去対象がカレントレイヤーの場合はカレントを外す
            this.design.currentLayer = null;
        }
        // 消去対象が選択レイヤーにあった場合は選択を外す
        var isSelected = false;
        for(var layer of this.design.selectLayers)
        {
            if(layer == this.deleteLayer)
            {
                isSelected = true;
                break;
            }
        }
        if(isSelected)
        {
            this.design.removeSelectLayer(this.deleteLayer);
        }

        // レイヤーの削除
        this.parent.removeLayer(this.deleteLayer);

        // 連番文字対応
        if(this.deleteLayer instanceof NumberLayer) { this.deleteLayer.updateDocument(false); }

        this.doneCallback();
    }
}
